import Feature27 from './Feature27'
export default Feature27
